// extracted by mini-css-extract-plugin
export default {"searchInput":"SeriesSearch_searchInput__5Uhfr","searchContainer":"SeriesSearch_searchContainer__BXxuH"};